module.exports = __webpack_public_path__ + "img/slider_8.e949c617.jpg";